import { Controller } from '@hotwired/stimulus';

/**
 * AdpLocationMappingFormController
 *
 * Manages the Payroll Client ID input on the ADP Location Mapping form:
 *   - Pre-populates the field with the currently saved value of the selected Decisely Location.
 *   - Renders the field as disabled by default (read-only preview, will not be submitted).
 *   - Reveals an "Edit" button; clicking it enables the field so the admin can change the value.
 *   - When the Decisely Location dropdown changes, refreshes the displayed value and resets to disabled.
 *
 * @example
 *   <form data-controller="adp-location-mapping-form"
 *         data-adp-location-mapping-form-payroll-client-ids-value='{"42":"MSPDG","43":""}'>
 *     <select data-adp-location-mapping-form-target="groupLocationSelect"
 *             data-action="change->adp-location-mapping-form#groupLocationChanged">
 *       <option value="42">NorthStar Hotel</option>
 *       <option value="43">NorthStar Restaurant</option>
 *     </select>
 *
 *     <input type="text"
 *            data-adp-location-mapping-form-target="payrollClientIdField"
 *            disabled />
 *
 *     <button type="button"
 *             data-adp-location-mapping-form-target="editButton"
 *             data-action="click->adp-location-mapping-form#enableEdit">Edit</button>
 *   </form>
 */
export default class extends Controller {
  static targets = ['groupLocationSelect', 'payrollClientIdField', 'editButton'];

  static values = { payrollClientIds: Object };

  connect() {
    this.disableField();
  }

  groupLocationChanged() {
    if (!this.hasGroupLocationSelectTarget) return;

    const selectedId = this.groupLocationSelectTarget.value;
    const value = this.payrollClientIdsValue[selectedId] || '';
    this.payrollClientIdFieldTarget.value = value;
    this.disableField();
  }

  enableEdit(event) {
    event.preventDefault();
    this.payrollClientIdFieldTarget.disabled = false;
    this.payrollClientIdFieldTarget.focus();
    if (this.hasEditButtonTarget) this.editButtonTarget.style.display = 'none';
  }

  disableField() {
    this.payrollClientIdFieldTarget.disabled = true;
    if (this.hasEditButtonTarget) this.editButtonTarget.style.display = '';
  }
}
